export default "__VITE_ASSET__568976dc__"